<template>
    <g-empty image-height="small" class="products-out-of-stock">
        <div slot="image">
            <g-icon name="inbox" size="emptyState"/>
        </div>
        <g-typography slot="description" tag="p" :value="message" class="break-new-line" text-align="center"/>
    </g-empty>
</template>
<script>
    export default {
        name: 'OutOfStock',
        props: {
            customMessage: {
                type: String,
            },
        },
        computed: {
            message() {
                return !!this.customMessage ? this.customMessage : 'Looks like we\'re all out of stock! If you think this was a mistake, please email us.';
            },
        },
    }
</script>
<style lang="scss" scoped>
    .products-out-of-stock {
        padding: $g-spacing-8;
        margin-top: 8rem;
    }

    .break-new-line {
        white-space: pre-line;
    }
</style>
